import styled from 'styled-components';

import {
  Flex,
  H100,
} from 'web-styled';

export const Header = styled(Flex).attrs({
  flex: '0 0 50px',
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  padding: 0 30px;
  border-bottom: 1px solid rgba(40, 45, 48, 0.1);
  background-color: #f9f9f9;
  position:  sticky;
  top: 0;
  z-index: 11;

  @media print {
    display: none;
  }
`;

export const Title = styled(H100)`
  color: ${props => props.theme.colors.primary};
`;
